<div class="activity-filter-list">
  <div class="activity-filter-list__filters">
    <button *ngFor="let activity of ACTIVITY_FILTER_LIST" type="button"
            class="activity-filter-list__btn"
            [class.activity-filter-list__btn--active]="selectedActivity === activity.key"
            (click)="onClickActivity(activity.key)">
      <mat-icon *ngIf="activity.fontIcon || activity.svgIcon" [fontSet]="activity.fontSet"
                [fontIcon]="activity.fontIcon" [svgIcon]="activity.svgIcon"
                class="activity-filter-list__icon">
      </mat-icon>
      <mat-icon *ngIf="activity.icon" class="activity-filter-list__icon">
        {{ activity.icon }}
      </mat-icon>
      <span class="activity-filter-list__btn-label">{{ activity.label }}</span>
    </button>
  </div>
  <img *ngIf="showAttribution" src="assets/images/powered_by_google_on_white.png"
       class="activity-filter-list__attribution" alt="powered by Google">
</div>
